import React, { Component } from 'react'
import { InputError } from '@foodsby/nutrient'
import { Article, Card } from '../common/Layout'
import {
  Location,
  LocationBuilding,
  LocationContainer
} from '../common/Location'
import { connect } from 'react-redux'
import {
  joinUserAndConfirmAddress,
  loadJoinInfoStart
} from '../../redux/modules/join'
import { SimpleSpinner } from '../common/SimpleSpinner'
import { selectCurrentLocationWithAddress } from '../../redux/modules/selectors'

export class JoinPage extends Component {
  componentDidMount() {
    this.props.loadJoinInfoStart(this.props.match.params.token)
  }

  render() {
    const {
      joinInfoError,
      joinSaveError,
      isJoinInfoLoading,
      joinUserAndConfirmAddress,
      location
    } = this.props
    return (
      <Article>
        <div className="row center-xs">
          <div className="col-xs-12">
            {isJoinInfoLoading ? (
              <SimpleSpinner />
            ) : joinInfoError ? (
              <Card>
                <InputError visible={joinInfoError}>
                  Either the link you clicked is now expired, or there was a
                  problem. Please try again later, or contact Foodsby support.
                </InputError>
              </Card>
            ) : (
              <Card>
                <h3 className="primary">Please confirm your address:</h3>
                {location && (
                  <div className="row center-xs">
                    <Location>
                      <LocationContainer>
                        <LocationBuilding
                          showLink={false}
                          name={location.deliveryLocationName}
                          address={location.address}
                        />
                      </LocationContainer>
                    </Location>
                  </div>
                )}
                <div className="row">
                  <div className="col-xs-12 middle-xs">
                    <button
                      onClick={joinUserAndConfirmAddress}
                      className="primary button"
                    >
                      Confirm Address
                    </button>
                  </div>
                  {joinSaveError && (
                    <InputError
                      visible={joinSaveError && joinSaveError !== null}
                    >
                      {joinSaveError.message}
                    </InputError>
                  )}
                </div>
              </Card>
            )}
          </div>
        </div>
      </Article>
    )
  }
}

const mapStateToProps = state => {
  const {
    locationId,
    username,
    isJoinInfoLoading,
    joinInfoError,
    joinSaveError
  } = state.join

  const location = selectCurrentLocationWithAddress(state)

  return {
    locationId,
    username,
    isJoinInfoLoading,
    joinInfoError,
    joinSaveError,
    location
  }
}

const mapDispatchToProps = {
  loadJoinInfoStart,
  joinUserAndConfirmAddress
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JoinPage)
